import React, { useEffect, useState } from 'react';
import styles from 'components/podiatry/page.module.scss';
import { StateType } from 'reducer';
import { actionTypesOfReasonForVisit } from 'reducer/actionType';
import { usePersistRFVReducer } from 'reducer/reasonForVisit';
import { PatientDTO } from 'types/patients';
import { useSelector } from 'react-redux';
import { RootState } from 'store/store';
import UploaderElement from 'components/common/uploaderElement';
import MetaTag from 'components/meta';
import useMediaUpload from 'hooks/useMediaUpload';
import Button from 'components/common/button';
import { MultimediaType } from 'utils/constants';

type Props = {
  nextPage: number;
  nextOrSubmitButton: (nextPage: number, submit?: boolean) => void;
};

const title = 'If it would be helpful for your diagnosis, feel free to upload a photo';

function DiagnosisUploadPhotoScreen({
  nextPage,
  nextOrSubmitButton,
}: Props) {
  const { mediaUpload } = useMediaUpload();
  const [image, setImage] = useState<string>('');
  const [state, dispatch] = usePersistRFVReducer();

  const communique = useSelector(
    (state: RootState) => state.communique,
  ) as unknown as PatientDTO;

  useEffect(() => {
    if (state) {
      const data = state.find(
        (object: StateType) => object.name === actionTypesOfReasonForVisit.DIAGNOSIS_UPLOAD_PHOTO,
      );
      setImage(data.value);
    }
  }, []);

  const clickNextOrSubmit = async (nextPage: number) => {
    if (image) {
      mediaUpload({
        patientId: communique.patientId,
        dataUrl: image,
        multimediaType: MultimediaType.VisitNoteImage,
        extraName: 'Diagnosis-photo',
      });
    }

    await dispatch({
      type: actionTypesOfReasonForVisit.DIAGNOSIS_UPLOAD_PHOTO,
      name: title,
      value: image,
    });

    nextOrSubmitButton(nextPage);
  };

  const onChangeDiagnosisPhoto = (img: string) => {
    setImage(img);
  };

  return (
    <>
      <MetaTag title={title} />
      <div>
        <h2 className={`marginTopZero ${styles.titleText}`}>{title}</h2>
        <p className={`${styles.titleTextSubText} mb-2`}>
          Photos of both feet are the most helpful so that we can compare
        </p>
        <UploaderElement
          getImage={onChangeDiagnosisPhoto}
          imageBase64={image}
          acceptExtensions="image/*"
        />
      </div>
      <div className="next-button-fixed">
        <Button onClick={() => clickNextOrSubmit(nextPage)}>
          Next
        </Button>
      </div>
    </>
  );
}

export default DiagnosisUploadPhotoScreen;
